import { createSelector } from 'reselect';

export const getToken = state => state.getIn(['user', 'token'], null);
export const getProfile = state => state.getIn(['user', 'profile'], null);

export const isAuthenticated = createSelector([getToken], token => {
  return token !== null;
});

export const getChildren = state => state.getIn(['user', 'children'], []);



// WEBPACK FOOTER //
// ./app/redux/selectors/user.js